
import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';

export default Vue.extend({
  data() {
    return {
      bannerStyle: {
        width: '100%',
        padding: '10px 20px',
        background: 'black',
        color: 'white',
        marginBottom: '10px',
        borderRadius: '4px',
      },
    };
  },
  computed: {
    ...mapState('user/profile', {
      currentUser: 'currentProfile',
    }),
    ...mapGetters('user/profile', ['isInNorthAmerica', 'isInCA']),
  },
  methods: {
    hasOwnedProduct(ampsId) {
      return this.currentUser.products.some(product => product.owned && product.id === ampsId);
    },
  },
});
